export const sectorOrder = ['SCREEN', 'GAMES', 'MUSIC', 'FASHION', 'CREATOR', 'ADVERTISING', 'AI', 'LIVE', 'CRAFT', 'SOCIAL', 'EDUCATION', 'INFRASTRUCTURE'];
